// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.arrbox[data-v-c71ff98a] {\r\n  background-color: white;\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n  margin-bottom: 0px;\r\n  text-align: left;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  width: 460px;\n}\r\n", ""]);
// Exports
module.exports = exports;
